export default __webpack_public_path__ + "static/media/kuchnia8.1721572b.jpg";